<template>
  <div>
    <h1>Oops!</h1>
    <h2>Theres nothing here. (404)</h2>
  </div>
</template>

<script>
export default {
  name: "NotFound"
}
</script>

<style scoped>

</style>